export default "__VITE_ASSET__B2ljI4b5__"